import { first } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, DestroyRef } from '@angular/core';
import { LOGIN } from '@core/constants/RoutingsPath';
import { Router } from '@angular/router';
import { AuthService } from '@core/modules/authentication/services/auth.service';

@Component({
    selector: 'app-remember',
    templateUrl: './remember.component.html',
    styleUrls: ['./remember.component.scss'],
    standalone: false
})
export class RememberComponent {
  loginPath = `/${LOGIN}`;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly destroyRef: DestroyRef
  ) {}

  onSubmit(formValues: any) {
    const { email } = formValues;
    this.authService
      .remember(email)
      .pipe(takeUntilDestroyed(this.destroyRef), first())
      .subscribe({
        next: () => {
          this.router.navigate([LOGIN]);
        },
        error: () => {
          console.error('Error remember');
        }
      });
  }
}
